import axios from 'axios';
import connection from './connection';
import {OperationDto,OperationResponseModel,AllOperationsResponseModel, VarientIdRequest, OperationsDropDownResponse} from '@gtpl/shared-models/production-management';
export class OperationService{
    URL = connection.DEPLOY_URL + '/operations';

    async createOperation(operationDto: OperationDto):Promise<OperationResponseModel>{
        return await axios.post(this.URL+'/createOperation',operationDto)
            .then(res => {
                return res.data
            })
    }

    async updateOperation(operationDto: OperationDto):Promise<OperationResponseModel>{
        return await axios.post(this.URL+'/updateOperation',operationDto)
           .then(res => {
               return res.data
           })
    }
    async getAllOperations(inputReq?:VarientIdRequest):Promise<AllOperationsResponseModel> {
      
        return await axios.post(this.URL + '/getAllOperations',inputReq)
            .then(res => {
                return res.data
            })     
    }

    async getAllOperationsDropDown():Promise<OperationsDropDownResponse> {
        return await axios.post(this.URL + '/getAllOperationsDropDown')
            .then(res => {
                return res.data
            })     
    }
    
    async activateOrDeactivateOperation(operationDto: OperationDto):Promise<OperationResponseModel>{
        return await axios.post(this.URL+'/activateOrDeactivateOperation',operationDto)
           .then(res => {
               return res.data
           })
    }
}